import { useState } from 'react';

import { IItem, IPurchaseOrder, ITestProvider } from '../../views/PxwProcessDevices/types';

export interface IInputsState {
  selectedTestProvider: ITestProvider | null;
  selectedPO: IPurchaseOrder | null;
  itemList: IItem[];
  selectedItem: IItem | null;
  matchQty: number | '';
  mismatchFunctionalQty: number | '';
  mismatchNonFunctionalQty: number | '';
}

type IQtyUpdate = Partial<
  Pick<IInputsState, 'matchQty' | 'mismatchFunctionalQty' | 'mismatchNonFunctionalQty'>
>;

const QTY_RESET = {
  matchQty: '' as const,
  mismatchFunctionalQty: '' as const,
  mismatchNonFunctionalQty: '' as const,
};

const INITIAL: IInputsState = {
  selectedTestProvider: null,
  selectedPO: null,
  itemList: [],
  selectedItem: null,
  ...QTY_RESET,
};

export const usePxwSelectionInputs = (onResultInvalidated: () => void) => {
  const [inputs, setInputs] = useState<IInputsState>(INITIAL);

  const reset = () => setInputs(INITIAL);

  const updateQty = (partial: IQtyUpdate) => setInputs((prev) => ({ ...prev, ...partial }));

  const handleTestProviderChange = (_: any, value: ITestProvider | null) => {
    setInputs((prev) => ({
      ...prev,
      selectedTestProvider: value,
      selectedPO: null,
      itemList: [],
      selectedItem: null,
      ...QTY_RESET,
    }));
    onResultInvalidated();
  };

  const handlePOChange = (_: any, value: IPurchaseOrder | null) => {
    setInputs((prev) => ({
      ...prev,
      selectedPO: value,
      itemList: value ? value.items : [],
      selectedItem: null,
      ...QTY_RESET,
    }));
    onResultInvalidated();
  };

  const handleItemChange = (_: any, value: IItem | null) => {
    setInputs((prev) => ({ ...prev, selectedItem: value, ...QTY_RESET }));
    onResultInvalidated();
  };

  return {
    inputs,
    reset,
    updateQty,
    handleTestProviderChange,
    handlePOChange,
    handleItemChange,
  };
};
